import { EntityService } from './EntityService';
import { INAODefForm } from '../types';

export class NAODefFormService extends EntityService<INAODefForm> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/NAODefForms`);
    }

    public welcomeAccess(): Promise<string> {
        return super.readString(`?welcomeAccess=`).then((result: string): string => {
            return result;
        });
    }
}